import VerticalSliderItem from './VerticalSliderItem'
export default VerticalSliderItem
